<template>
    <div class="form-group">
        <label v-if="label" :for="named" class="control-label">{{ trans(label) }}</label>
        <textarea class="form-control" v-on:input="updateValue($event.target.value)" :id="named" :name="named" v-model="value"></textarea>
    </div>
</template>
<script>
    export default{
        props: {
            id: { default: '' },
            name: { default: '' },
            label: { default: '' },
            value: { default: '' }
        },
        created() {
//            this.$eventHub.$on('reset-data', this.reset);
        },
        computed: {
            named: function () {
                // Compute name depending on how deep it should be
                if (this.name == '') {
                    if(this.id == '') {
                        return this.label;
                    }
                    return this.id;
                }
                return this.name + '[' +  this.id + ']';
            }
        },
        methods: {
            updateValue: function (value) {
                // When the internal value changes, we $emit an event. Because this event is
                // named 'input', v-model will automatically update the parent value
                this.$emit('input', value);
            },
                // Reset Form Data
            reset () {
                this.value = '';
            }
        }
    }
</script>